import classNames from 'classnames';

type OverlayProps = {
  className?: string;
  children?: React.ReactNode;
};

export function Overlay({ className, children }: OverlayProps) {
  return (
    <div className={classNames('fixed z-20 bg-overlay left-0 top-0 right-0 bottom-0', className)}>
      {children}
    </div>
  );
}
